{
  "daytime": {
    "earlier": "dopoldne",
    "later": "popoldne"
  },
  "login": {
    "title": "Prijava",
    "text": "Prijavi se v svoj račun",
    "button": "Prijava",
    "stressLevel": "Stress Level",
    "errorDialog": {
      "message": "Napačno uporabniško ime ali geslo!",
      "accept": "V redu"
    },
    "placeholder": {
      "username": "Prosim, vnesite uporabniško ime.",
      "password": "Prosim, vnesite geslo."
    }
  },
  "sidebar": {
    "bulletins": "Avalanche.report",
    "dangerSources": "Danger Sources",
    "observations": "Opazovanja",
    "qfa": "QFA",
    "modelling": "Modeliranje",
    "modellingForecast": "Napoved",
    "modellingZamg": "ZAMG multi model",
    "modellingZamgECMWF": "ZAMG ECMWF-EPS",
    "modellingZamgCLAEF": "ZAMG CLAEF-EPS",
    "modellingZamgMeteogram": "GeoSphere meteogram",
    "modellingSnowpack": "SNOWPACK model",
    "modellingSnowpackMeteo": "SNOWPACK modelled meteo",
    "weatherbox": "Weatherbox",
    "awsome": "AWSOME",
    "snowpack": "SNOWPACK",
    "geosphere": "GeoSphere",
    "translations": "Translations"
  },
  "menu": {
    "logout": "Izpiši se",
    "language": "Jezik",
    "en": "angleščina",
    "de": "nemščina",
    "fr": "francoščina",
    "it": "italijanščina",
    "es": "španščina",
    "ca": "katalonščina",
    "oc": "Aranese",
    "fullscreen": "Cel zaslon",
    "settings": "Nastavitve",
    "statistics": "Statistika",
    "admin": "Admi",
    "region": "Regija",
    "education": "Znanje"
  },
  "matrix": {
    "label": {
      "snowpackStability": "Stabilnost snežne odeje",
      "frequency": "Pogostost",
      "avalancheSize": "Velikost plazu",
      "dangerRating": "Ocena nevarnosti",
      "override": "(prepiši oceno nevarnosti)",
      "matrix": "Matrica",
      "referToFairStability": "Nanaša se na dobro stabilnost",
      "referToPoorStability": "Nanaša se na slabo stabilnost",
      "dangerLevel1": "Stopnja nevarnosti 1 (majhna)"
    }
  },
  "dangerSources": {
    "status": {
      "missing": "manjka",
      "available": "na voljo",
      "forecast": "napoved",
      "analysis": "analiza",
      "loading": "Loading danger sources ...",
      "saveError": "Danger source could not be saved!",
      "loadDangerSourcesError": "Danger sources could not be loaded!",
      "loadVariantsError": "Danger source variants could not be loaded!"
    },
    "variantStatus": {
      "active": "active",
      "dormant": "dormant",
      "inactive": "inactive"
    },
    "tooltip": {
      "read": "Read danger sources",
      "edit": "Edit danger sources"
    },
    "table": {
      "loadMore": "Load {{count}} more days",
      "title": {
        "forecast": "Napoved",
        "analysis": "Analiza"
      }
    },
    "create": {
      "variantStatus": "Stanje",
      "variantEditable": "This variant can be edited.",
      "variantNotEditable": "This variant can not be edited.",
      "noVariantsForSelectedDay": "No variants defined for this date.",
      "tooltip": {
        "editDangerSource": "Edit danger source",
        "loadVariants": "Load variants from the day before",
        "showVariantsOnMap": "Show variants on map",
        "edit": "Uredi mikro-regije",
        "copy": "Copy variant",
        "delete": "Delete variant",
        "compare": "Compare variant",
        "forecast": "Compare with forecast"
      },
      "createDangerSource": "Create danger source",
      "createVariant": "Create new variant",
      "noDangerSources": "No danger sources",
      "title": {
        "slab": "Plošča",
        "weakLayer": "Šibka plast",
        "loose": "Nesprijet sneg",
        "glide": "Drseči sneg",
        "matrix": "Matrica",
        "characteristics": "Characteristics",
        "comment": "Komentar"
      },
      "label": {
        "glidingSnowActivity": "Gliding snow activity",
        "snowHeight": "Višina snežne odeje",
        "snowHeightAverage": "Average snow height",
        "zeroDegreeIsotherm": "Nulta izoterma",
        "looseSnowMoisture": "Vlažnost nesprijetega snega",
        "looseSnowGrainShape": "Oblika zrn nesprijetega snega",
        "slabGrainShape": "Oblika zrn snežne plošče",
        "slabThickness": "Debelina snežne plošče",
        "slabHandHardness": "Trdota snežne plošče, merjena z roko",
        "slabHardnessProfile": "Trdota snežne plošče",
        "slabEnergyTransferPotential": "Potencial snežne plošče za prenos energije",
        "slabDistribution": "Slab distribution",
        "weakLayerGrainShape": "Oblika zrn šibke plasti",
        "weakLayerGrainSize": "Velikost zrn šibke plasti",
        "weakLayerPersistent": "Weak layer persistent",
        "weakLayerThickness": "Debelina šibke plasti",
        "weakLayerStrength": "Nosilnost šibke plasti",
        "weakLayerWet": "Šibka plast je mokra",
        "weakLayerCrustAbove": "Šibka plasat pod skorjo",
        "weakLayerCrustBelow": "Šibka plast nad skorjo",
        "weakLayerPosition": "Položaj šibke plasti",
        "weakLayerCreation": "Nastanek šibke plasti",
        "weakLayerDistribution": "Razporeditev šibkih plasti",
        "dangerSpotRecognizability": "Prepoznavnost nevarnih mest",
        "remoteTriggering": "Proženje na daljavo",
        "hasDaytimeDependency": "Daytime dependency",
        "dangerIncreaseWithElevation": "Povečanje nevarnosti z višino",
        "runoutIntoGreen": "Runout into green",
        "penetrateDeepLayers": "Penetrate deep layers",
        "highestDangerAspect": "Pobočja z največjo nevarnostjo",
        "dangerPeak": "Danger peak",
        "slopeGradient": "Naklon pobočja",
        "naturalRelease": "Natural release",
        "terrainTypes": "Terrain types",
        "dangerSigns": "Znaki nevarnosti",
        "aspects": "Usmerjenost"
      },
      "createDangerSourceDialog": {
        "title": "Naslov",
        "description": "Opis",
        "save": "Shrani",
        "cancel": "Prekliči"
      },
      "editDangerSourceDialog": {
        "title": "Naslov",
        "description": "Opis",
        "update": "Posodobitev",
        "cancel": "Prekliči"
      },
      "deleteVariantDialog": {
        "message": "Ali želiš shraniti to različico?",
        "accept": "Da",
        "reject": "Ne"
      },
      "noRegionDialog": {
        "message": "Izberi vsaj eno svojo mikro-regijo",
        "accept": "V redu"
      },
      "discardDialog": {
        "message": "Ali želiš zavreči spremembe?",
        "accept": "Da",
        "reject": "Ne"
      },
      "saveErrorDialog": {
        "message": "Napaka pri shranjevanju virov nevarnosti!",
        "accept": "V redu"
      },
      "loadDialog": {
        "message": "Do you want to load all danger source variants from the day before?",
        "accept": "Da",
        "reject": "Ne"
      }
    }
  },
  "avalancheType": {
    "title": "Vrsta plazu",
    "label": {
      "slab": "SPRIJET",
      "loose": "NESPRIJET",
      "glide": "ZDRSNI"
    },
    "tooltip": {
      "slab": "Plaz sprijetega snega",
      "loose": "Plaz nesprijetega snega",
      "glide": "Zdrsni plaz"
    }
  },
  "elevation": {
    "title": "Nadmorska višina",
    "high": "Pod",
    "low": "Nad",
    "treeline": "Gozdna meja"
  },
  "bulletins": {
    "title": "Avalanche.report",
    "tooltip": {
      "edit": "Uredi bilten",
      "read": "Preberi bilten",
      "copy": "Kopiraj bilten",
      "paste": "Prilepi bilten",
      "cancel": "Prekliči kopiranje",
      "update": "Uredi",
      "submit": "Oddaj",
      "submitUpdate": "Oddaj posodobitev",
      "publishChange": "Objavi zdaj (brez sporočil)",
      "publishUpdate": "Objavi zdaj",
      "caaml": "Pokaži CAAML",
      "json": "Pokaži JSON",
      "create": "Naredi bilten",
      "preview": "Predogled biltena (PDF)",
      "check": "Preveri bilten",
      "info": "Prikaži stanje objave",
      "loadSuggestionFromDangerSources": "Naloži predloge",
      "deleteAllWarningRegions": "Izbriši vse plazovne regije",
      "publishAll": "Objavi vse plazovne regije",
      "publishAllNoMessages": "Objavi vse plazovine regije (brez sporočil)",
      "mediaFile": "Naloži media datoteko"
    },
    "status": {
      "submittedInfo": "Bilten bo objavljen ob 17:00.",
      "resubmittedInfo": "Bilten bo objavljen ob 8:00.",
      "publishedInfo": "Bilten je bil objavljen",
      "noPublicationInfo": "Bilten NE BO objavljen samodejno.",
      "loadingPreview": "Ustvarjanje predogleda PDF ...",
      "loading": "Nalaganje biltena ...",
      "loadMoreBulletins": "Naloži {{count}} več biltenov",
      "publishing": "Objavljam bilten ...",
      "submitting": "Oddajam bilten ...",
      "saveError": "Biltena ni mogoče shraniti!",
      "loadBulletinsError": "Biltenov ni mogoče naložiti!"
    },
    "create": {
      "tooltip": {
        "edit": "Uredi mikro-regije",
        "copy": "Kopiraj regijo",
        "delete": "Izbriši regijo",
        "deleteProblem": "Izbriši problem",
        "compare": "Primeraj regije",
        "undo": "Razveljavi zadnjo spremebo v regiji",
        "redo": "Ponovi spremembo v regiji",
        "createRegion": "Ustvari regij",
        "cancel": "Prekliči",
        "acceptSuggestion": "Sprejmi predlagane regije",
        "rejectSuggestion": "Zavrni predlagane regije",
        "saveChanges": "Shrani spremembe",
        "discardChanges": "Zavrzi spremembe",
        "incompleteAvalancheProblem": "Nepopoln plazovni problem",
        "saveBulletin": "Shrani bilten",
        "discardBulletin": "Zavrzi spremembe biltena",
        "loadBulletin": "Naloži bilten prejšnjega dne",
        "uploadJsonBulletin": "Naloži bilten v formatu JSON",
        "downloadJsonBulletin": "Shrani bilten v formatu JSON",
        "daytimeDependency": "Daytime dependency",
        "treeline": "Gozdna meja",
        "tendency": {
          "decreasing": "Nevarnost plazov se zmanjša",
          "steady": "Nevarnost plazov ostane enaka",
          "increasing": "Nevarnost plazov se poveča",
          "danger": "Nevarnost plazov"
        },
        "textcat": {
          "edit": "Uredi",
          "copy": "Kopiraj",
          "paste": "Prilepi",
          "example": "Naloži vzorčno besedilo",
          "delete": "Izbriš"
        },
        "moveUpAvalancheProblem": "Move avalanche problem up",
        "moveDownAvalancheProblem": "Move avalanche problem down",
        "dangerRatingDirectionUp": "Navzgor",
        "dangerRatingDirectionDown": "Navzdol"
      },
      "save": "Shrani",
      "discard": "Zavrzi",
      "back": "Nazaj",
      "createAggregatedRegion": "Nova regije",
      "pasteAggregatedRegion": "Prilepi regijo",
      "pendingSuggestions": "Predlogi",
      "rejectSuggestion": "Zavrni",
      "acceptSuggestion": "Sprejmi",
      "cancelCopyBulletin": "Prekliči",
      "createAvalancheProblem": "Nov problem",
      "ownRegions": "Lastne regije",
      "foreignRegions": "Tuje regije",
      "externalRegions": "Zunanje regije",
      "mapSelectRegion": "Izberi regije na zemljevidu.",
      "statusHeader": "Stanje biltena.",
      "translationStatusHeader": "Status of the translation",
      "suggestions": "Predlogi",
      "noBulletinsForSelectedDay": "Za ta da ni določenih regij",
      "autosave": "Samodejno shranjeno",
      "regionEditable": "To regijo je mogoče urediti.",
      "regionNotEditable": "Te regije ni mogoče urediti.",
      "regionLocked": "Ta regija je zaklenjena.",
      "changeDangerRatingElevation": "Extend the danger level",
      "mapTop": "Zemljevid zgoraj",
      "mapLeft": "Zemljevid ob strani",
      "showExternalRegions": "Prikaži zunanje regije",
      "hideExternalRegions": "Skrij zunanje regije",
      "showNotes": "Prikaže opombe",
      "hideNotes": "Skrij opombe",
      "incompleteAvalancheProblem": "Nepopolno",
      "label": {
        "generalHeadlineComment": "General overall headline",
        "importantObservations": "Important observations",
        "avalancheProblems": "Plazovni problem",
        "aspects": "Usmerjenost",
        "highlights": "Posebno opozorilo",
        "avActivityHighlights": "Headline avalanche situation",
        "avActivityComment": "Opis plazovne nevarnosti",
        "snowpackStructureComment": "Opis sestave snežne odeje",
        "dangerPatterns": "Vzorci nevarnosti",
        "tendencyComment": "Description of tendency",
        "synopsisComment": "Weather synopsis",
        "notes": "Opombe"
      },
      "copyRegion": {
        "label": "Kopiraj regijo v drug bilten",
        "select": "Prilepi v ...",
        "currentBulletin": "Ta bilten"
      },
      "title": {
        "avalancheProblem": "Plazovni problemi",
        "dangerDescription": "Opis plazovne nevarnosti",
        "forenoon": "Dopoldne",
        "afternoon": "Popoldne",
        "snowpackStructure": "Sestava snežne odeje",
        "tendency": "Obeti",
        "synopsis": "Vreme",
        "showTranslations": "Skrij prevode",
        "hideTranslations": "Prikaži prevode"
      },
      "placeholder": {
        "notes": "Sem si zapiši opombe .."
      },
      "pmDialog": {
        "noIFrameSupport": "Tvoj brskalnik ne podpira IFrame!"
      },
      "discardDialog": {
        "message": "Ali želiš zavreči spremembe?",
        "accept": "Da",
        "reject": "Ne"
      },
      "deleteAggregatedRegionDialog": {
        "message": "Ali želiš izbrisati to regijo?",
        "accept": "Da",
        "reject": "Ne"
      },
      "noRegionDialog": {
        "message": "Izberi vsaj eno svojo mikro-regijo",
        "accept": "V redu"
      },
      "loadDialog": {
        "message": "Ali želiš naložiti biltene prejšnjega dne?",
        "accept": "Da",
        "reject": "Ne"
      },
      "deleteAllWarningRegionsDialog": {
        "message": "Ali želiš izbrisati vse regije?",
        "accept": "Da",
        "reject": "Ne"
      },
      "loadAutoSaveDialog": {
        "message": "Ali želiš naložiti samodejno shranjene biltene?",
        "accept": "Da",
        "reject": "Ne"
      },
      "saveErrorDialog": {
        "message": "Med shranjevanjem biltenov je prišlo do napake!",
        "accept": "V redu"
      },
      "translationErrorDialog": {
        "message": "There was an error translating the bulletins!",
        "accept": "Ok"
      },
      "changeErrorDialog": {
        "message": "Med spreminjanjem biltenov je prišlo do napake!",
        "accept": "V redu"
      },
      "loadingErrorDialog": {
        "message": "Med nalaganjem biltenov je prišlo do napake!",
        "accept": "V redu"
      },
      "loadingJsonFileErrorDialog": {
        "message": "Med nalaganjem biltenov iz JSON je prišlo do napake!",
        "accept": "V redu"
      },
      "avalancheProblemErrorDialog": {
        "message": "Manjkajo plazovni problem, pobočja, stabilnost snežne odeje, pogostost in/ali velikost plazu za vsak en plazovni problem!",
        "accept": "V redu"
      },
      "loadAvActivityCommentExampleTextDialog": {
        "message": "For which situation do you want to load an example text?",
        "newSnow": "Nov sneg",
        "windSlab": "Napihan sneg",
        "persistentWeakLayers": "Trdožive šibke plasti",
        "wetSnow": "Moker sneg",
        "glidingSnow": "Drseč sneg",
        "favourableSituation": "Ugodne razmere",
        "cancel": "Prekliči"
      },
      "removeDaytimeDependencyDialog": {
        "message": "Katere plazovne probleme želiš obdržati?",
        "cancel": "Prekliči"
      },
      "strategicMindsetDialog": {
        "title": "Strategic Mindsets",
        "introduction": "The \"Strategic Mindsets\" are intended to express our mental attitude with regard to the avalanche situation and its development in the corresponding warning region. It should not be derived directly from the hazard assessment, but rather understood and used as an intuitive impression of the overall situation. The \"Strategic Mindsets\" are therefore primarily a communication tool. Using the mindsets and associated definitions, we forecasters can quickly and efficiently exchange information about the development of the hazard situation and find a common language for communication.",
        "description": {
          "title": "Description:",
          "text": {
            "assessment": "There is <b>great uncertainty</b> in the hazard assessment due to <b>insufficient information</b> from the field.",
            "stepping_out": "<b>Decreasing tendency</b> of the hazard situation (also within a danger level).",
            "status_quo": "Same hazardous situation. <b>No significant change</b> compared to the previous day.",
            "stepping_back": "<b>Increasing tendency</b> of the hazard situation (also within a danger level).",
            "entrenchment": "<b>Almost constant, tense hazardous situation.</b> The main danger comes from (a) <b>persistent weak layer</b>(s) susceptible to interference.",
            "free_ride": "<b>Low avalanche danger</b> with generally stable snow cover. Only small avalanches are possible in extremely steep terrain. ",
            "high_alert": "Exceptional situation with <b>high or very high avalanche danger</b>. Spontaneous avalanches of <b>very large or extreme magnitude</b> are possible",
            "spring_diurnal": "Wet snow avalanches during the course of the day, which are subject to a <b>clear diurnal cycle</b>, are decisive for the risk assessment."
          }
        },
        "communication": {
          "title": "Communication:",
          "text": {
            "assessment": "Avalanche situation must be checked locally. Restraint is recommended.",
            "stepping_out": "Gradual decrease in danger. However, caution is still required and the improving situation should be assessed locally before entering riskier terrain.  ",
            "status_quo": "Hazardous situation is unchanged. Feedback from observers helps to better outline the hazardous situation. More favourable terrain should be communicated with emphasis. ",
            "stepping_back": "Clear communication of the increase in avalanche danger - even within a danger level. Information on the causes supports comprehensibility in communication. ",
            "entrenchment": "Caution and restraint are required. Situation hardly changes. If possible, provide as precise information as possible on distribution and possibility to trigger. Increased communication of observations that reveal the situation and trigger restraint.",
            "free_ride": "Little text. Emphasise the generally favourable overall situation and potentially isolated hazard areas",
            "high_alert": "Communication across all channels. The focus is no longer on winter sports. Danger even in areas that are not usually at risk of avalanches.",
            "spring_diurnal": "Favourable situation in the morning, increasing during the day. Assessment should be made locally by observing the softening of the melt-freeze crust and the increasing soaking of the snow cover."
          }
        },
        "examples": {
          "title": "Examples:",
          "text": {
            "assessment": "Start of the season.",
            "stepping_out": "Cooling leads to a decrease in the risk of wet snow avalanches after a warm and humid weather phase.",
            "status_quo": "Consistent wind-slab problem with cold temperatures, loose snow and wind.",
            "stepping_back": "Abundant fresh snowfall leads to an increase in the danger situation.",
            "entrenchment": "Critical persistent weak layers problem with potential for dangerously large avalanches. The situation is only stabilising very slowly and requires a great deal of restraint.",
            "free_ride": "Low avalanche danger, no persistent weak layers, all terrain has already been groomed.",
            "high_alert": "Danger level 4 or higher due to large amounts of fresh snow and/or problematic, persistent weak layers. ",
            "spring_diurnal": "Spring situation with dry high-pressure weather and moderate temperatures with otherwise mostly stable old snow cover."
          }
        },
        "strategicMindset": {
          "assessment": "Velika negotovost",
          "stepping_out": "Improving",
          "status_quo": "Status Quo",
          "stepping_back": "Deteriorating",
          "entrenchment": "Persistent Unstable",
          "free_ride": "Favorable",
          "high_alert": "High Alert",
          "spring_diurnal": "Spring Diurnal"
        }
      },
      "decisionTree": {
        "filepath": "./assets/img/decision_tree-en.svg",
        "feedbackURL": "https://admin.avalanche.report/umfrage-entscheidungsbaum/en/",
        "decisionTree": "Decision tree",
        "feedback": "Odziv",
        "save": "Shrani",
        "discard": "Zavrzi"
      }
    },
    "table": {
      "title": {
        "date": "Datum"
      },
      "status": {
        "missing": "manjka",
        "draft": "osnutek",
        "submitted": "oddano",
        "published": "objavljeno",
        "updated": "posodobljeno",
        "resubmitted": "ponovno oddano",
        "republished": "ponovno objavljeno"
      },
      "publishBulletinsDialog": {
        "message": "Ali želiš objaviti bilten?",
        "missingDangerRating": "Ni določena stopnja nevarnosti",
        "missingRegion": "Nekatere regije nimajo določene stopnje",
        "duplicateRegion": "Nekatere regije so vključene v več regij",
        "missingAvActivityHighlights": "Headline avalanche situation missing",
        "missingAvActivityComment": "Manjka opis plazovne nevarnosti",
        "missingSnowpackStructureHighlights": "Headline snowpack structure missing",
        "missingSnowpackStructureComment": "Manjka opis sestave snežne odeje",
        "pendingSuggestions": "Pending suggestions",
        "incompleteTranslation": "Nepopoln prevod",
        "accept": "Da",
        "reject": "Ne"
      },
      "publicationStatusDialog": {
        "headline": "Stanje objave",
        "publishedBy": "Objavil:",
        "publishedAt": "Objavljeno:",
        "validFor": "Velja za:",
        "title": {
          "prod": "Serious stuff",
          "test": "Test system",
          "task": "Task",
          "language": {
            "all": "ALL",
            "de": "NEM",
            "it": "IT",
            "en": "ANG"
          }
        },
        "email": {
          "label": "Emails",
          "tooltip": "Pošlji e-pošto",
          "success": "E-pošta uspešno poslana!",
          "error": "E-pošte ni bilo mogoče poslati!"
        },
        "telegram": {
          "label": "Sporočilo Telegram",
          "tooltip": "Pošlji sporočilo Telegram",
          "success": "Sporočilo na Telegram uspešno poslano!",
          "error": "Sporočila na Telegram ni bilo mogoče poslati!"
        },
        "whatsapp": {
          "label": "Sporočilo WhatsApp",
          "tooltip": "Pošlji sporočilo WhatsApp",
          "success": "Sporočilo WhatsApp poslano!",
          "error": "Sporočila WhatsApp ni bilo mogoče poslati!"
        },
        "push": {
          "label": "Potisno obvestil",
          "tooltip": "Pošlji potisno obvestil",
          "success": "Potistno obvestilo poslano!",
          "error": "Potisnega obvestila ni bilo mogoče poslati!"
        },
        "accept": "V redu"
      },
      "mediaFileDialog": {
        "headline": "Media File",
        "important": "POMEMBNO",
        "missingFile": "Izbrana ni nobena datoteka!",
        "uploadError": "Nalaganje ni uspelo!",
        "accept": "Pošlj",
        "reject": "Prekliči"
      },
      "publishBulletinsErrorDialog": {
        "message": "Med objavo biltena je prišlo do napake!",
        "accept": "V redu"
      },
      "submitBulletinsDialog": {
        "message": "Ali želiš oddati bilten?",
        "missingDangerRating": "Ni določena stopnja nevarnosti",
        "missingRegion": "Nekatere regije nimajo določene stopnje",
        "missingAvActivityHighlights": "Headline avalanche situation missing",
        "missingAvActivityComment": "Manjka opis plazovne nevarnosti",
        "missingSnowpackStructureHighlights": "Headline snowpack structure missing",
        "missingSnowpackStructureComment": "Manjka opis sestave snežne odeje",
        "pendingSuggestions": "Pending suggestions",
        "accept": "Da",
        "reject": "Ne"
      },
      "submitBulletinsErrorDialog": {
        "message": "Med oddajo biltena je prišlo do napake!",
        "accept": "V redu"
      },
      "submitBulletinsDuplicateRegionDialog": {
        "message": "Nekatere regije so vključene v več regij. Biltena ni mogoče oddati.",
        "accept": "V redu"
      },
      "checkBulletinsErrorDialog": {
        "message": "Med preverjanjem biltena je prišlo do napake!",
        "accept": "V redu"
      },
      "previewErrorDialog": {
        "message": "Predogleda ni mogoče naložiti!",
        "accept": "V redu"
      },
      "checkBulletinsDialog": {
        "message": "Preveri bilten",
        "missingDangerRating": "Ni določena stopnja nevarnosti",
        "missingRegion": "Nekatere regije nimajo določene stopnje",
        "missingAvActivityHighlights": "Headline avalanche situation missing",
        "missingAvActivityComment": "Manjka opis plazovne nevarnosti",
        "missingSnowpackStructureHighlights": "Headline snowpack structure missing",
        "missingSnowpackStructureComment": "Manjka opis sestave snežne odeje",
        "pendingSuggestions": "Pending suggestions",
        "incompleteTranslation": "Nepopoln prevod",
        "ok": "(everything alright)",
        "accept": "V redu"
      },
      "publishAllDialog": {
        "message": "Do you want to publish all regions?",
        "changeMessage": "Do you want to publish all regions? (no messages)",
        "accept": "Da",
        "reject": "Ne"
      }
    }
  },
  "training": {
    "training": "Training",
    "timestamp": "Training timestamp"
  },
  "admin": {
    "loadingStatistics": "Ustvarjanje CSV ...",
    "server-configuration": {
      "title": "Strežni",
      "button": {
        "create": "Ustvari strežnik",
        "save": "Shrani"
      },
      "table": {
        "name": "Ime",
        "username": "Uporabniško ime",
        "password": "Geslo",
        "publishAt5PM": "Objavi ob 17:0",
        "publishAt8AM": "Objavi ob 8:00",
        "pdfDirectory": "Mapa za PDF",
        "htmlDirectory": "Mapa za HTML",
        "serverImagesUrl": "Pot do slik na strežnik",
        "dangerLevelElevationDependency": "Elevation dependency of danger level",
        "mapsPath": "Pot do zemljevidov",
        "mediaPath": "Path to media files",
        "mapProductionUrl": "URL for map production",
        "apiUrl": "API URL"
      },
      "success": "Konfiguracija je bila uspešno shranjena.",
      "error": "Konfiguracije ni bilo mogoče shraniti."
    },
    "region-configuration": {
      "title": "Regija",
      "button": {
        "create": "Ustvari regij",
        "save": "Shrani"
      },
      "table": {
        "general": {
          "title": "Splošn",
          "id": "ID"
        },
        "publication": {
          "title": "Publication",
          "publishBulletins": "Objavi napoved plazov",
          "publishBlogs": "Objavi blog",
          "createCaamlV5": "Naredi CAAML v5",
          "createCaamlV6": "Naredi CAAML v6",
          "createJson": "Naredi JSON",
          "createMaps": "Naredi zemljevide",
          "createPdf": "Naredi PDF",
          "sendEmails": "Pošlji E-pošto",
          "createSimpleHtml": "Naredi preprost HTML",
          "sendTelegramMessages": "Pošlji Telegram sporočil",
          "sendWhatsAppMessages": "Pošlji WhatsApp sporočil",
          "sendPushNotifications": "Pošlji potisno sporočilo",
          "pdfColor": "Barva PDF",
          "emailColor": "Barva E-pošte",
          "pdfMapYAmPm": "Y za PDF zemljevid (am/pm)",
          "pdfMapYFd": "Y za PDF zemljevid (fd)",
          "pdfMapWidthAmPm": "Širina zemljevida za PDF (am/pm)",
          "pdfMapWidthFd": "Širina zemljevida za PDF (fd)",
          "pdfMapHeight": "Višina zemljevida za PDF",
          "pdfFooterLogo": "Logotič za nogo v PDF",
          "pdfFooterLogoColorPath": "Logotip za nogo v PDF (barvni)",
          "pdfFooterLogoBwPath": "Logotip za nogo v PDF (čb)",
          "simpleHtmlTemplateName": "Predloga preprostega HTML",
          "geoDataDirectory": "Geodata directory",
          "mapLogoColorPath": "Logotip za zemljevid (barvni)",
          "mapLogoBwPath": "Logotip za zemljevid (čb)",
          "mapLogoPosition": "Položaj logotipa na zemljevidu",
          "imageColorbarColorPath": "Barvna lestvica (barvna)",
          "imageColorbarBwPath": "Barvna lestvica (čb)",
          "enabledLanguages": "Omogočeni jeziki",
          "ttsLanguages": "Text-to-speech languages"
        },
        "components": {
          "title": "Components",
          "enableDangerSources": "Enable danger sources",
          "enableObservations": "Enable observations",
          "enableModelling": "Enable modelling",
          "enableWeatherbox": "Enable weather box"
        },
        "configuration": {
          "title": "Configuration",
          "showMatrix": "Show matrix",
          "enableMediaFile": "Enable media file",
          "enableStrategicMindset": "Enable strategic mindset",
          "enableStressLevel": "Enable stress level",
          "enableAvalancheProblemCornices": "Enable avalanche problem CORNICES",
          "enableAvalancheProblemNoDistinctAvalancheProblem": "Enable avalanche problem NO DISTINCT AVALANCHE PROBLEM",
          "enableGeneralHeadline": "Enable general overall headline for bulletins",
          "enableWeatherTextField": "Enable text input for weather synopsis",
          "infoIframeUrl": "URL to external Website embedded via an IFrame"
        },
        "languageConfiguration": {
          "title": "Language configuration"
        }
      },
      "success": "Konfiguracija je bila uspešno shranjena.",
      "error": "Konfiguracije ni bilo mogoče shraniti."
    },
    "users": {
      "title": "Uporabnik",
      "button": {
        "create": "Ustvari uporabnika"
      },
      "tooltip": {
        "edit": "Uredi uporabnika",
        "changePassword": "Spremeni gesl",
        "delete": "Izbriši uporabnika"
      },
      "table": {
        "name": "Ime",
        "email": "E-pošta",
        "organization": "Organizacija",
        "regions": "Regije",
        "roles": "Vloge"
      },
      "deleteUserModalDialog": {
        "message": "Ali želiš izbrisati uporabnika?",
        "accept": "Da",
        "reject": "Ne"
      },
      "deleteUser": {
        "success": "Uporabnik je bil izbrisan",
        "error": "Uporabnika ni mogoče izbrisati"
      },
      "createUser": {
        "success": "Uporabnik je bil ustvarjen",
        "error": "Uporabnika ni mogoče ustvariti"
      },
      "updateUser": {
        "success": "Uporabnik je bil posodobljen",
        "error": "Uporabnika ni mogoče posodobiti"
      }
    },
    "createUser": {
      "table": {
        "image": "Image",
        "name": "Ime",
        "email": "E-pošta",
        "organization": "Organizacija",
        "password": "Geslo",
        "password2": "Ponovi geslo",
        "roles": "Vloge",
        "regions": "Regije"
      },
      "error": {
        "name": {
          "required": "Prosim, vnesi ime"
        },
        "email": {
          "required": "Prosim, vnesi e-naslov",
          "invalid": "E-naslov je neveljaven"
        },
        "password": {
          "required": "Prosim, vnesi geslo",
          "length": "Geslo mora vsebovati vsaj 8 znakov",
          "mismatch": "Gesli se ne ujemata"
        }
      },
      "button": {
        "create": "Ustvari uporabnika",
        "update": "Posodobi uporabnika",
        "cancel": "Prekliči"
      }
    },
    "observations": {
      "table": "Tabela",
      "map": "Zemljevid",
      "gallery": "Galerija",
      "filters": "Filtri",
      "details": "Podrobnosti",
      "title": "Opazovanja",
      "newObservation": "Novo opazovanje",
      "exportObservations": "Izvozi opazovanja (GeoJSON)",
      "exportStatistics": "Izvozi statistiko (CSV)",
      "toggleFilterBar": "Prikaži/skrij vrstico s filtri",
      "button": {
        "submit": "Shrani"
      },
      "label": {
        "dateRange": "Obdobje",
        "observer": "Opazovalec"
      },
      "selectRegion": {
        "placeholder": "Regija",
        "selectionLabel": "število izbranih regij: {0}"
      },
      "selectSources": {
        "placeholder": "Viri",
        "selectionLabel": "Število izbranih virov: {0}"
      },
      "charts": {
        "charts": "Charts",
        "nan": "Without specification",
        "reload": "Ponovno naloži",
        "classify": "Classify",
        "label": "Label",
        "invert": "Invert",
        "reset": "Ponastavi",
        "aspect": {
          "caption": "Usmerjenost pobočja"
        },
        "elevation": {
          "caption": "Nadmorska višina"
        },
        "stability": {
          "caption": "Stabilnost"
        },
        "observationType": {
          "caption": "Vrsta opazovanja"
        },
        "importantObservation": {
          "caption": "Important"
        },
        "avalancheProblem": {
          "caption": "Plazovni problem"
        },
        "dangerPattern": {
          "caption": "Danger Pattern"
        },
        "dangerSource": {
          "caption": "Danger Source"
        },
        "days": {
          "caption": "Dan"
        }
      }
    },
    "blog": {
      "title": "Blog",
      "language": {
        "title": "Jezik",
        "de": "NEM",
        "it": "IT",
        "en": "ANG"
      },
      "all": {
        "tooltip": "Pošlji sporočila na e-pošto, Telegram, WhatsApp in potisna obvestila",
        "success": "Sporočila na e-pošto, Telegram, WhatsApp in potisna obvestila so bila uspešno poslana!",
        "error": "Sporočil na e-pošto, Telegram, WhatsApp in potisnih obvestil ni bilo mogoče poslati!"
      },
      "email": {
        "tooltip": "Pošlji e-sporočila",
        "success": "E-pošta je bila uspešno poslana!",
        "error": "E-pošte ni bilo mogoče poslati!"
      },
      "telegram": {
        "tooltip": "Send via Telegram Channel",
        "success": "Telegram successfully sent!",
        "error": "Telegram could not be sent!"
      },
      "whatsapp": {
        "tooltip": "Send via WhatsApp Channel",
        "success": "WhatsApp successfully sent!",
        "error": "WhatsApp could not be sent!"
      },
      "push": {
        "tooltip": "Send via Push Notifications",
        "success": "Push successfully sent!",
        "error": "Push could not be sent!"
      }
    }
  },
  "settings": {
    "title": "Nastavitve",
    "changePassword": {
      "title": "Spremeni gesl",
      "oldPassword": {
        "label": "Trenutno geslo",
        "placeholder": "Trenutno geslo"
      },
      "newPassword1": {
        "label": "Novo gesl",
        "placeholder": "Novo gesl"
      },
      "newPassword2": {
        "label": "Novo geslo (ponovi)",
        "placeholder": "Novo geslo"
      },
      "submit": "Spremeni gesl",
      "passwordChanged": "Geslo je bilo uspešno spremenjeno",
      "passwordChangeError": "Gesla ni bilo mogoče spremeniti",
      "passwordIncorrect": "Vneseno trenutno geslo je napačn",
      "error": {
        "oldPassword": {
          "required": "Prosim, vnesi svoje trenutno geslo\n"
        },
        "newPassword": {
          "required": "Prosim, vnesi novo geslo",
          "mismatch": "Gesli se ne ujemata"
        }
      }
    },
    "display": {
      "title": "Prikaz",
      "table": {
        "showCaaml": "Pokaži CAAML",
        "showJson": "Pokaži JSON"
      }
    }
  },
  "statistics": {
    "title": "Statistika",
    "bulletins": "Lavinski bilteni",
    "dangerSources": "Danger Sources",
    "button": {
      "submit": "Shrani"
    },
    "label": {
      "dateRange": "Obdobje",
      "extended": "Extended",
      "duplicates": "Dvojniki"
    }
  },
  "dangerRating": {
    "noRating": "no rating",
    "low": "majhna",
    "moderate": "zmerna",
    "considerable": "znatna",
    "high": "velika",
    "veryHigh": "zelo velika"
  },
  "avalancheProblem": {
    "newSnow": "Nov sneg",
    "new_snow": "Nov sneg",
    "windSlab": "Napihan sneg",
    "wind_slab": "Napihan sneg",
    "persistentWeakLayers": "Trdožive šibke plasti",
    "persistent_weak_layers": "Trdožive šibke plasti",
    "wetSnow": "Moker sneg",
    "wet_snow": "Moker sneg",
    "glidingSnow": "Drseč sneg",
    "gliding_snow": "Drseč sneg",
    "cornices": "Opasti",
    "noDistinctAvalancheProblem": "No distinct avalanche problem",
    "no_distinct_avalanche_problem": "No distinct avalanche problem",
    "favourableSituation": "Ugodne razmere",
    "favourable_situation": "Ugodne razmere"
  },
  "dangerPattern": {
    "dp1": "dp.1: globoka trdoživa šibka plast",
    "dp2": "vn.2: zdrsni plazovi",
    "dp3": "dp.3: dež",
    "dp4": "dp.4: ohladitev po toploti / otoplitev po mrazu",
    "dp5": "dp.5: sneženje po dolgem hladnem obdobju",
    "dp6": "dp.6: mrzel nesprijet sneg z vetrom",
    "dp7": "vn.7: tanka snežna odeja ob globoki snežni odeji",
    "dp8": "vn.8: zakopan površinski srež",
    "dp9": "dp.9: zakopano babje pšeno",
    "dp10": "dp.10: spomladanske razmere"
  },
  "strategicMindset": {
    "title": "Strategic Mindset",
    "assessment": "Velika negotovost",
    "stepping_out": "Improving",
    "status_quo": "Status Quo",
    "stepping_back": "Deteriorating",
    "entrenchment": "Persistent Unstable",
    "free_ride": "Favorable",
    "high_alert": "High Alert",
    "spring_diurnal": "Spring Diurnal"
  },
  "observationType": {
    "DrySnowfallLevel": "Dry snowfall level",
    "TimeSeries": "Time series",
    "Incident": "Incident",
    "Profile": "Snow profile",
    "Closure": "Closure",
    "Blasting": "Blasting",
    "Avalanche": "Avalanche",
    "Evaluation": "Evaluation",
    "SimpleObservation": "Preprosto opazovanje",
    "Webcam": "Spletna kamera"
  },
  "importantObservation": {
    "ForBlog": "Za blog",
    "SurfaceHoar": "Površinski srež",
    "Graupel": "Babje pšeno",
    "StabilityTest": "Preizkus stabilnosti",
    "IceFormation": "Ice formation",
    "VeryLightNewSnow": "Very light new snow"
  },
  "elevationTolerance": {
    "exact": "natančno",
    "50m": "±50m",
    "100m": "±100 m",
    "200": "±200 m"
  },
  "elevationPeriod": {
    "duringPrecipitationEvent": "Dry snowfall boundary for the entire precipitation event",
    "observationPeriod": "Dry snowfall boundary at the time of observation"
  },
  "aspect": {
    "N": "S",
    "NE": "SV",
    "E": "V",
    "SE": "JV",
    "S": "J",
    "SW": "JZ",
    "W": "Z",
    "NW": "SZ"
  },
  "role": {
    "SUPERADMIN": "Super Administrator",
    "ADMIN": "Administrator",
    "FORECASTER": "Prognosti",
    "FOREMAN": "Foreman",
    "OBSERVER": "Opazovalec",
    "TRANSLATOR": "Translator"
  },
  "tendency": {
    "decreasing": "Nevarnost plazov se bo zmanjšala",
    "steady": "Nevarnost plazov bo ostala enaka",
    "increasing": "Nevarnost plazov se bo povečala"
  },
  "snowpackStability": {
    "unknown": "neznano",
    "good": "dobra",
    "fair": "zadovoljiva",
    "poor": "slaba",
    "very_poor": "zelo slaba"
  },
  "frequency": {
    "none": "(skoraj) nič",
    "few": "nekaj",
    "some": "nekaj",
    "many": "veliko"
  },
  "avalancheSize": {
    "small": "majhni",
    "medium": "srednji",
    "large": "veliki",
    "very_large": "zelo veliki",
    "extreme": "izjemno veliki"
  },
  "complexity": {
    "easy": " Easy",
    "challenging": " Challenging",
    "complex": " Complex"
  },
  "glidingSnowActivity": {
    "low": "majhna",
    "medium": "srednji",
    "high": "velika"
  },
  "wetness": {
    "dry": "suh",
    "moist": "vlažen",
    "wet": "moker"
  },
  "characteristic": {
    "low": "majhna",
    "medium": "srednji",
    "high": "velika",
    "very_high": "zelo velika"
  },
  "thickness": {
    "thin": "tanek",
    "thick": "debel"
  },
  "snowpackPosition": {
    "upper": "zgornji",
    "middle": "srednj",
    "lower": "spodnj",
    "ground": "tla"
  },
  "weakLayerCrust": {
    "no": "brez",
    "partly": "deloma",
    "yes": "da/z"
  },
  "creationProcess": {
    "radiation_recrystallization": "sevanje",
    "diurnal_recrystallization": "dnevno",
    "melt_layer_recrystallization": "melt layer",
    "surface_hoar_formation": "površinski srež"
  },
  "recognizability": {
    "very_easy": "zelo preprosto",
    "easy": "preprosto",
    "hard": "težko",
    "very_hard": "zelo težko"
  },
  "distribution": {
    "isolated": "osamljeni",
    "specific": "značilni",
    "widespread": "obsežni"
  },
  "probability": {
    "likely": "verjetno",
    "possible": "mogoče",
    "unlikely": "malo verjetno"
  },
  "detailedDaytime": {
    "evening": "večer",
    "first_night_half": "v prvi polovici noči",
    "second_night_half": "v drugi polovici noč",
    "morning": "zjutraj",
    "forenoon": "dopoldne",
    "afternoon": "popoldne"
  },
  "slopeGradient": {
    "moderately_steep": "zmerno strm",
    "steep": "strm",
    "very_steep": "zelo strm",
    "extremely_steep": "izjemno strmo"
  },
  "handHardness": {
    "fist": "P",
    "four_fingers": "4P",
    "one_finger": "1P",
    "pencil": "S",
    "knife": "N",
    "ice": "L"
  },
  "hardnessTendency": {
    "decreasing": "mehkejši pod",
    "steady": "enakomeren",
    "increasing": "mehkejši nad"
  },
  "terrainType": {
    "gullies_and_bowls": "grape in kotli",
    "adjacent_to_ridgelines": "v bližini grebenov",
    "distant_from_ridgelines": "daleč od grebenov",
    "in_the_vicinity_of_peaks": "v bližini vrhov",
    "pass_areas": "okoli prevalov",
    "shady_slopes": "senčna pobočja",
    "sunny_slopes": "sončena pobočja",
    "grassy_slopes": "travnata pobočja",
    "cut_slopes": "cut slopes",
    "wind_loaded_slopes": "wind loaded slopes",
    "base_of_rock_walls": "vznožje skalnih sten",
    "behind_abrupt_changes_in_the_terrain": "behind abrupt changes in the terrain",
    "transitions_into_gullies_and_bowls": "transitions into gullies and bowls",
    "areas_where_the_snow_cover_is_rather_shallow": "areas where the snow cover is rather shallow",
    "transitions_from_a_shallow_to_a_deep_snowpack": "transitions from a shallow to a deep snowpack",
    "highly_frequented_off_piste_terrain": "highly frequented off piste terrain",
    "little_used_backcountry_terrain": "little used backcountry terrain",
    "places_that_are_protected_from_the_wind": "places that are protected from the wind",
    "regions_exposed_to_the_foehn_wind": "regions exposed to the foehn wind",
    "regions_with_a_lot_of_snow": "regions with a lot of snow",
    "regions_exposed_to_precipitation": "regions exposed to precipitation",
    "regions_exposed_to_heavier_precipitation": "regions exposed to heavier precipitation"
  },
  "dangerSign": {
    "shooting_cracks": "shooting cracks",
    "whumpfing": "whumpfing",
    "fresh_avalanches": "fresh avalanches",
    "glide_cracks": "glide cracks"
  },
  "changeRegionDialog": {
    "message": "Do you want to change the region?",
    "accept": "Da",
    "reject": "Ne"
  },
  "zamg": {
    "table": "Tabela",
    "map": "Zemljevid",
    "region": "Regija",
    "newSnow": "Nov sneg"
  },
  "snowpack": {
    "plotType": {
      "LWC_stratigraphy": "moker sneg: vodnatost",
      "wet_snow_instability": "moker sneg: nestabilnost",
      "Sk38_stratigraphy": "trdoživa šibka plast: kazalnik stabilnosti SK38",
      "stratigraphy": "trdoživa šibka plast: stratigrafija snežne odeje"
    },
    "aspect": {
      "flat": "ravnina",
      "north": "sever",
      "south": "jug"
    },
    "meteo": {
      "new_snow_plot_3day": "nov sneg (3 dni)",
      "new_snow_plot_7day": "nov sneg (7 dni)",
      "new_snow_plot_1month": "nov snega (31 dni)",
      "new_snow_plot_season": "nov sneg (sezona)",
      "new_snow_plot_forecast": "nov snega (napoved)",
      "wet_snow_plot_3day": "moker sneg (3 dni)",
      "wet_snow_plot_7day": "moker sneg (7 dni)",
      "wet_snow_plot_1month": "moker sneg (31 dni)",
      "wet_snow_plot_season": "moker sneg (sezona)",
      "wet_snow_plot_forecast": "moker sneg (napoved)",
      "HS_table_24h": "snow height table (1d)",
      "HS_table_72h": "snow height table (3d)",
      "HS_table_season": "snow height table (season)",
      "HS_table_forecast": "snow height table (forecast)",
      "TA_table_24h": "temperature table (1d)",
      "TA_table_72h": "temperature table (3h)",
      "TA_table_season": "temperature table (season)"
    }
  },
  "grainShape": {
    "PP": {
      "code": "PP",
      "class": "padavinski delci"
    },
    "PPgp": {
      "code": "PPgp",
      "class": "babje pšeno"
    },
    "DF": {
      "code": "DF",
      "class": "Decomposing and Fragmented precipitation particles"
    },
    "RG": {
      "code": "RG",
      "class": "zrnec"
    },
    "FC": {
      "code": "FC",
      "class": "srež"
    },
    "DH": {
      "code": "DH",
      "class": "globinski srež"
    },
    "SH": {
      "code": "SH",
      "class": "površinski srež"
    },
    "MF": {
      "code": "MF",
      "class": "srenec"
    },
    "MFcr": {
      "code": "MFcr",
      "class": "sren, osrenica"
    },
    "IF": {
      "code": "IF",
      "class": "Ice Formations"
    }
  },
  "button": {
    "yes": "da/z",
    "no": "brez"
  },
  "observations": {
    "allowEdit": "Uredi zunanje opazovanje",
    "allowEditTooltip": "This will prevent overwrites from {{ value }}",
    "editIconTooltip": "Edited observation - receives no updates from {{ value }}",
    "aspect": "Usmerjenost pobočja",
    "authorName": "Ime avtorja",
    "avalancheLength": "Dolžina plazu",
    "avalancheProblem": "Plazovni problem",
    "avalancheSize": "Velikost plazov",
    "avalancheType": "Vrsta plazu",
    "avalancheWidth": "Širina plazu",
    "search": "Išči",
    "count": "Število opazovanj:",
    "elevationTolerance": "Točnost podatkov o višini",
    "elevationPeriod": "Elevation time period",
    "layers": {
      "observers": "Opazovalci",
      "weatherStations": "Vremenske postaje",
      "webcams": "Spletne kamere",
      "observations": "Opazovanja"
    },
    "weatherStations": {
      "tooltips": {
        "drySnowfallLevel": "Dry snowfall level",
        "globalRadiation": "Globalno sevanje",
        "newSnow": "Nov sneg",
        "snowLine": "Snow line",
        "snowHeight": "Višina snežne odeje",
        "snowDifference": "Snow difference",
        "airTemperature": "Temperatura zraka",
        "airTemperatureMax": "Najvišja temperatura zraka",
        "airTemperatureMin": "Najnižja temperatura zraka",
        "surfaceTemperature": "Temperatura površja",
        "surfaceHoar": "Potential surface hoar formation",
        "surfaceHoarCalc": "Potential surface hoar formation (Lehning et. al.)",
        "dewPoint": "Temperatura rosišča",
        "relativeHumidity": "Vlažnost zraka",
        "windDirection": "Smer vetra",
        "windSpeed": "Hitrost vetra",
        "windGust": "Sunki vetra"
      }
    },
    "webcams": {
      "tooltips": {
        "minusTenMinutes": "10 minut nazaj",
        "minusOneHour": "1 uro nazaj",
        "plusTenMinutes": "10 minut naprej",
        "plusOneHour": "1 uro naprej"
      }
    },
    "button": {
      "add": "Dodaj opazovanje",
      "save": "Shrani opazovanje",
      "delete": "Izbriši opazovanje",
      "deleteConfirm": "Izbrišem opazovanje?",
      "discard": "Zavrzi",
      "copyDate": "Kopiraj datum dogodka"
    },
    "comment": "Komentar",
    "content": "Vsebina",
    "dangerRating": "Stopnja nevarnosti",
    "dangerSource": "Danger source",
    "elevation": "Nadmorska višina",
    "elevationRange": "Elevation range",
    "elevationLowerBound": "Elevation lower bound",
    "elevationUpperBound": "Elevation upper bound",
    "eventDate": "Datum dogodka",
    "eventType": "Vrsta dogodka",
    "eventTypes": {
      "IMPORTANT": "Pomemben dogodek",
      "NEIGHBOR_REGION": "Neighbouring region",
      "NORMAL": "Normal event",
      "PERSON_DEAD": "Nesreča (mrtvi)",
      "PERSON_INJURED": "Nesreča (poškodovani)",
      "PERSON_NO": "Dogodek brez ljudi",
      "PERSON_UNINJURED": "Dogodek brez poškodovanih",
      "PERSON_UNKNOWN": "Dogodek (neznano)",
      "TRAFFIC": "Promet"
    },
    "externalURL": "Zunanji URL (npr. do zbirke fotografij)",
    "fractureDepth": "Fracture depth",
    "hasCoordinates": "Ima koordinate",
    "incline": "Incline",
    "latitude": "Geografska širina",
    "locationName": "Lokacija",
    "longitude": "Geografska višina",
    "observationType": "Vrsta opazovanja",
    "personInvolvement": "Person involvement",
    "reportDate": "Datum poročila",
    "showTable": "Tabela",
    "withoutCoordinates": "Opazovanje brez koordinat:",
    "sidebar": {
      "filter": {
        "title": "Filter"
      },
      "legend": {
        "title": "Legenda"
      },
      "sources": {
        "title": "Viri podatkov"
      },
      "views": {
        "title": "Pogledi"
      }
    }
  },
  "personInvolvement": {
    "Dead": "Nesreča (mrtvi)",
    "Injured": "Nesreča (poškodovani)",
    "No": "Dogodek brez ljudi",
    "Uninjured": "Dogodek brez poškodovanih",
    "Unknown": "Dogodek (neznano)"
  },
  "units": {
    "cm": "cm",
    "mm": "mm",
    "m": "m"
  },
  "qfa": {
    "day": "Dan",
    "time": "Čas",
    "back": "Nazaj",
    "parameters": {
      "DUST": "puščavski prah",
      "N": "skupna oblačnost v /8",
      "Nh": "visoka oblačnost v /8",
      "Nm": "srednja oblačnost v /8",
      "Nl": "nizka oblačnost v /8",
      "N-CU": "konvektivna oblačnost v /8",
      "AUSL.T": "trigger temperature",
      "SHW-IX": "Showalter-Index",
      "WX -CUF": "significant weather: NIL (none), RASH (rain), TS (thunder storm)",
      "RR": "skupna količina padavin [mm]",
      "RR-str": "stratiformne padavine [mm]",
      "CONV": "konvektivne padavine [mm]",
      "SN": "padavine v obliki snega [mm]",
      "SN--RA": "meja sneženja [m]",
      "QAO ": "{{value}} hPa eq. mean wind, direction and strength, [°] and [m/s]",
      "QAN": "mean wind on the ground, direction and strength, [°] and [m/s]",
      "QANmax": "max. wind (gusts) on the ground [m/s]",
      "T ": "{{value}} hPa eq. temperature [°C]",
      "T m": "temperature on {{value}}m [°C]",
      "T 2m": "temperature on 2m [°C]",
      "Tk 2m": "temperature on 2m [°K]",
      "T GND": "ground temperature",
      "Max-ADI": "maximum mixing temperature [°C]",
      "Min Max": "min./max. temperature in the last 24h",
      "FROST": "zero degree line [m]",
      "W cm": "500 hPa eq. vertical wind [cm/s]",
      "W --": "700 hPa eq. vertical wind [cm/s]",
      "W s": "{{value}} hPa eq. vertical wind [cm/s]",
      "H ": "{{value}} hPa geopotential height [m]",
      "RF ": "{{value}} hPa eq. relative moisture [%]"
    }
  },
  "awsome": {
    "Aggregation band": "Aggregation band",
    "Date": "Datum",
    "Datetag": "Datetag",
    "Depth": "Depth",
    "Dry instability": "Dry instability",
    "fair (<0.77)": "fair (<0.77)",
    "fair (<1.05)": "fair (<1.05)",
    "Grain type": "Grain type",
    "LWC index": "LWC index",
    "New snow": "Nov sneg",
    "poor (<=3)": "poor (<=3)",
    "poor (<0.95)": "poor (<0.95)",
    "poor (>=0.77)": "poor (>=0.77)",
    "Punstable": "Punstable",
    "rather stable (<0.7)": "rather stable (<0.7)",
    "rather stable (<1)": "rather stable (<1)",
    "rather stable (>1.05)": "rather stable (>1.05)",
    "Size estimate": "Size estimate",
    "SK38 (RTA > 0.8)": "SK38 (RTA > 0.8)",
    "very poor (<=0.5)": "very poor (<=0.5)",
    "very poor (>3)": "very poor (>3)",
    "Wet instability": "Wet instability"
  }
}
